import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ChatService } from "../../services/chat/chat.services";
import { useLayoutContext } from "../../layouts/general-layout";
import { parseQuestionSteps } from "../../utils/parseSteps"; // Import the new function
import { RouterConstant } from "../../routers/index";
import ChatHeader from "../../components/chat-header";
import QuestionStepsList from "../../components/question-steps-list";
import { useQuestionsStore } from "../../utils/questionStore";
import { useStepsStore } from "../../utils/stepStore";
import { AudioService } from "../../services/text-to-audio/texttoaudio.service";
import { ExerciseQuestionsService } from "../../services/exercise-questions/exercise-questions.service";

import "./question-steps.scss";

interface Step {
    id: number;
    title: string;
    content: string;
}

const QuestionSteps: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useLayoutContext();
    const { ROUTERS_PATH } = RouterConstant;
    const { api, payload, from, previewPageState } = location.state || {};
    const [steps, setSteps] = useState<Step[]>([]);
    const [stepContents, setStepContents] = React.useState<string[]>([]);
    const [expanded, setExpanded] = useState<string | false>(false);
    const [selectedStep, setSelectedStep] = useState<number | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [stepHistory, setStepHistory] = useState<any | null>(null);
    const [selectedQuestionId, setSelectedQuestionId] = useState<number | null>(null);    
    const audioServiceInstance = new AudioService();
    const exerciseQuestionService = new ExerciseQuestionsService();
    const setCurrentStep = useQuestionsStore((s) => s.setCurrentSelectedStep);

    useEffect(() => {
        fetchSteps();
    }, [payload]);

    useEffect(() => {
        if (selectedQuestionId) {
            fetchStepHistory(selectedQuestionId);
        }
    }, [selectedQuestionId]);

      
    const fetchStepHistory = async (questionId: number) => {
    try {
        const response = await exerciseQuestionService.fetchExerciseStepsHistory(questionId);
        if (response?.steps?.length > 0) {
        const history = response.steps[0];
        setStepHistory(history);
        useStepsStore.getState().setStepHistory(history);
        }
    } catch (error) {
        console.error("Error fetching step history:", error);
    }};

    const fetchSteps = async () => {
        try {
            const chatServiceInstance = new ChatService();
            const response = await chatServiceInstance.GETQUESTIONSTEPS(payload);
            const selectedQuestionId = response.selected_question_id;
            setSelectedQuestionId(selectedQuestionId);
            const selectedQuestion = response.selected_question;
            payload.selected_question = selectedQuestion;
            useQuestionsStore.getState().setCurrentSelectedQuestion(selectedQuestionId);
            const parsed = parseQuestionSteps(response.response_content);
            const chatStepContents = parsed.map((s, index) => `<b>שלב ${index + 1}: ${s.title}</b> ${s.content}`);
            setStepContents(chatStepContents);
            setSteps(parsed);
            audioServiceInstance.handleTextToAudioByKey("questionsteps_voice_exaplin",true); 
            useQuestionsStore.getState().setSteps(selectedQuestionId, parsed);
        } catch (error: any) {
            console.error("Error fetching steps:", error);            
            setErrorMessage(t("readingStepsError"));             
        }
    };

    const handleAccordionChange = (panel: string, index: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
        setSelectedStep(isExpanded ? index : null);
    };

    const handleProceedToChat = (selectedStep: number | null) => {
        if (selectedStep !== null) {
            setCurrentStep(steps[selectedStep].id);
            const selectedStepId=steps[selectedStep].id;            
            navigate(ROUTERS_PATH.CHAT, {
                state: {
                    api: api,
                    payload: {
                        ...payload,
                        selected_step: stepContents[selectedStep],
                        selected_step_id: selectedStepId,
                    },
                    stepIndex: selectedStep,
                    stepContents: stepContents,
                    selectedQuestionId: selectedQuestionId,                    
                    from: ROUTERS_PATH.QUESTIONSTEPS,
                    previewPageState,
                    steps: steps
                },
            });
        }
    };

    const handleBack = () => {
        if (previewPageState?.from === ROUTERS_PATH.SELFTESTANSWERPREVIEW) {
            navigate(ROUTERS_PATH.SELFTESTANSWERPREVIEW, { state: previewPageState});
        } else {
            navigate(ROUTERS_PATH.EXERCISEQUESTIONS)
        }
    }

    return (
        <div className="question-steps">
            <ChatHeader
                chatHeading={`${t("sectionSteps")} - ${payload?.selected_question || ""}`}
                onBackClick={() => handleBack()}
            />
            <QuestionStepsList
                steps={steps}
                expanded={expanded}
                selectedStep={selectedStep}
                onAccordionChange={handleAccordionChange}
                handleProceedToChat={handleProceedToChat}                
                errorMessage={errorMessage}
                stepHistory={stepHistory}
            />
        </div>
    );
};

export default QuestionSteps;
